// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-process[data-v-8a8f8618]{position:fixed;z-index:10000;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.7);text-align:center;padding:1em;margin:0 auto 1em;display:inline-block;vertical-align:top}.loading-process>svg[data-v-8a8f8618]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute}.loader[data-v-8a8f8618]{width:60px;height:60px}svg path[data-v-8a8f8618],svg rect[data-v-8a8f8618]{fill:#00d0ff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
